'use client';

import clsx from 'clsx';
import {
  Tab as RAC_Tab,
  TabList as RAC_TabList,
  TabPanel as RAC_TabPanel,
  Tabs as RAC_Tabs
} from 'react-aria-components';

import { Stack } from '~/components/Layout/Stack';
import styles from './Tabs.module.css';
import type { TabContentProps, TabLabelProps, TabsListProps, TabsProps } from './Tabs.types';

const TabsContainer = ({ children, selectedKey, onSelectionChange, ...props }: TabsProps) => {
  return (
    <RAC_Tabs
      data-test-id="Tabs"
      className={styles.tabsContainer}
      selectedKey={selectedKey}
      onSelectionChange={onSelectionChange}
      {...props}
    >
      <Stack space="--by-space-600">{children}</Stack>
    </RAC_Tabs>
  );
};

const TabsList = ({ ariaLabel, children, variant = 'default' }: TabsListProps) => {
  return (
    <RAC_TabList
      aria-label={ariaLabel}
      className={clsx({
        [styles.tabsList]: variant === 'default',
        [styles.tabsListMinimal]: variant === 'minimal'
      })}
    >
      {children}
    </RAC_TabList>
  );
};

const Tab = ({ id, children, variant = 'default' }: TabLabelProps) => {
  return (
    <RAC_Tab
      id={id}
      className={clsx({
        [styles.tab]: variant === 'default',
        [styles.tabMinimal]: variant === 'minimal'
      })}
    >
      {children}
    </RAC_Tab>
  );
};

const TabContent = ({ id, children }: TabContentProps) => {
  return (
    <RAC_TabPanel id={id} className={styles.tabPanel}>
      {children}
    </RAC_TabPanel>
  );
};

export { TabsContainer, TabsList, Tab, TabContent };
